export var GlobalSearchModule;
(function (GlobalSearchModule) {
    GlobalSearchModule[GlobalSearchModule["Assets"] = 1] = "Assets";
    GlobalSearchModule[GlobalSearchModule["Knowledge"] = 2] = "Knowledge";
    GlobalSearchModule[GlobalSearchModule["Chat"] = 3] = "Chat";
    GlobalSearchModule[GlobalSearchModule["Files"] = 4] = "Files";
    GlobalSearchModule[GlobalSearchModule["Technicians"] = 5] = "Technicians";
    GlobalSearchModule[GlobalSearchModule["All"] = 6] = "All";
})(GlobalSearchModule || (GlobalSearchModule = {}));
export var GlobalSearchModuleStatusMap = new Map([
    [GlobalSearchModule.Assets, 'Assets'],
    [GlobalSearchModule.Knowledge, 'Knowledge'],
    [GlobalSearchModule.Chat, 'Chats'],
    [GlobalSearchModule.Files, 'Files'],
    [GlobalSearchModule.Technicians, 'Technicians'],
    [GlobalSearchModule.All, 'All']
]);
